import Cookies from 'js-cookie';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';

import {
  Sitemap as SitemapComponent,
  LogoutButton,
  SitemapDivider,
  SitemapLinkGroup,
  SitemapLink,
} from '@cfm-media/pwa-ui-components';
import { useStore } from '../core/store';

import { ContentWrapper } from '../components/content-wrapper';
import { PageWrapper } from '../components/page-wrapper';
import { isLimousineServiceActive } from './limousine-service';
import { urls } from '../urls';

export const Sitemap = observer(() => {
  const navigate = useNavigate();
  const { BookingStore } = useStore();

  const logout = async () => {
    try {
      navigator?.serviceWorker?.ready?.then((registration) => {
        registration?.active?.postMessage({ action: 'cache:clear' });
        console.log('App: Asked service worker to clear cache');
      });
    } catch (error) {
      console.error('App: Error clearing cache', error);
    }

    await fetch('/logout', { method: 'POST' })
      .then(() => {
        navigate(urls.login);
        Cookies.remove('hideSpecialCampaignModal');
      })
      .catch(() => {
        Cookies.remove('app_token');

        navigate(urls.login);
      });
  };

  return (
    <PageWrapper>
      <ContentWrapper>
        <SitemapComponent>
          <LogoutButton onClick={logout} />

          <SitemapDivider />
          {/* prettier-ignore */}
          <SitemapLink icon="icon-mapdot" href={urls.map}>Umgebung</SitemapLink>

          <SitemapDivider />
          {/* prettier-ignore */}
          <SitemapLink icon="icon-contact" href={urls.contact}>Kontakt</SitemapLink>

          <SitemapDivider />

          {/* prettier-ignore */}
          <SitemapLinkGroup label="Meine Reise" icon="icon-services">
            {BookingStore?.booking?.data?.flights?.length > 0 && <SitemapLink href={urls.flightDetails}>Flug</SitemapLink>}
            {BookingStore?.booking?.data?.hotels?.length > 0 && <SitemapLink href={urls.hotelDetails}>Unterkunft</SitemapLink>}
            {BookingStore?.booking?.data?.hasTransfer && <SitemapLink href={urls.transfer}>Transfer</SitemapLink>}
          </SitemapLinkGroup>

          {/* prettier-ignore */}
          <SitemapLinkGroup label="Extras" icon="icon-services">
            <SitemapLink href={urls.upgrades}>Zusatzleistungen</SitemapLink>
            <SitemapLink href={urls.insurance}>Reiseversicherung</SitemapLink>
            <SitemapLink href={urls.excursions.index}>Ausflüge</SitemapLink>
            <SitemapLink href={urls.rentalCar}>Mietwagen</SitemapLink>
            {isLimousineServiceActive(BookingStore) ? (<SitemapLink href={urls.limousineService}>Home2Gate - Airporttransfer</SitemapLink>) : null}
          </SitemapLinkGroup>

          {/* prettier-ignore */}
          <SitemapLinkGroup label="Infos & Services" icon="icon-services">
            <SitemapLink href={urls.documents}>Dokumente</SitemapLink>
            <SitemapLink href={urls.payment}>Bezahlung</SitemapLink>
            {BookingStore?.booking?.data?.flights?.length > 0 && <SitemapLink href={urls.airportParking}>Parken am Flughafen</SitemapLink>}
            <SitemapLink href={urls.entryConditions}>Einreiseinformationen</SitemapLink>
            {BookingStore?.validGeoDataFromHotels?.length > 0 && <SitemapLink href={urls.weather}>Wetter</SitemapLink>}
             {BookingStore?.booking?.data?.serviceName?.charAt(1) === 'T' && <SitemapLink href={urls.peopleAndPlaces}>Land und Leute</SitemapLink>}
          </SitemapLinkGroup>

          <SitemapLinkGroup label="Über die App" icon="icon-info" hideDivider>
            <SitemapLink href={urls.about}>Bentour</SitemapLink>
            <SitemapLink href={urls.imprint}>Impressum</SitemapLink>
            <SitemapLink href={urls.dataProtection}>Datenschutz</SitemapLink>
            <SitemapLink href={urls.termsAndConditions}>AGB</SitemapLink>
          </SitemapLinkGroup>
        </SitemapComponent>
      </ContentWrapper>
    </PageWrapper>
  );
});
